import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import {getElement, getElements} from './../utils/functional'

export default function init ({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.querySelector(`.${moduleClassName}_Carousel`)
  const swiperPaginationClass = `${moduleClassName}_Pagination`
  const swiperPaginationElement = el.querySelector(`.${moduleClassName}_Pagination`)

  let paginationSettings = false

  if(swiperPaginationElement){
    paginationSettings = {
      el: swiperPaginationElement,
      type: 'bullets',
      clickable: true,
    }
  }

  makeCarousel()

  // window.addEventListener('resize', makeCarousel)

  function makeCarousel () {
    initialiseCarousel(swiperContainer, {
      preloadImages: true,
      lazy: true,
      setWrapperSize: true,
      watchOverflow: true,
      slideClass: `${moduleClassName}_Slide`,
      pagination: paginationSettings,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
        stopOnLastSlide: false,
      },
    });
  }
}